(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Depository', Depository);

    Depository.$inject = ['$resource'];

    function Depository ($resource) {
        var resourceUrl =  'api/warehouse/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                params: {
                    path: 'pages'
                },
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                params:{
                    path: 'list'
                },
                isArray: true
            } ,
            'delete':{method:'DELETE'},
            'add': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {
                method: 'GET',
                params: {
                    path: 'getOne'
                }
            }
        });
    }
})();
